import * as React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Flex } from "@rebass/grid";
import { H2, Classes, Button, Intent } from "@blueprintjs/core";

import { MaxBound } from "../../atoms/Layout";
import { INavigationBarProps } from "../../organisms/NavigationBar";

interface IMatchParams {
  client: string;
  [key: string]: any;
}

const ActionNav: React.FC<INavigationBarProps> = (props) => {
  const history = useHistory();
  const match = useRouteMatch<IMatchParams>();

  const handleConfigClick = () => {
    const clientID = match.params.client;
    history.push(`/clients/${clientID}/config/dimensions`);
  };

  const LeftSideActionItems = React.memo(({ title, tabs, controls }: any) => (
    <Flex justifyContent="space-between">
      <Flex flex={1}>
        <H2>{title}</H2>
      </Flex>
      <Flex flex={1} justifyContent="center" alignItems="flex-end">
        {tabs}
      </Flex>
      <Flex flex={1} justifyContent="flex-end" alignItems="center">
        {controls}
      </Flex>
    </Flex>
  ));

  return (
    <Flex className={Classes.DARK} justifyContent="center">
      <MaxBound>
        {props.showConfig ? (
          <Flex justifyContent="space-between" alignItems="center">
            <LeftSideActionItems {...props}/>
            <Button intent={Intent.PRIMARY} onClick={handleConfigClick}>
              Master Configuration
            </Button>
          </Flex>
        ) : (
          <LeftSideActionItems {...props} />
        )}
      </MaxBound>
    </Flex>
  );
};

export default ActionNav;
